
import getPromiseCallback from '../../../utils/getPromiseCallback';

import { callPost } from '../../../serverApi/funcs';

import getBaseModuleOptions from './getBaseModuleOptions';

function getCallOptions(options) {
    return {
        ...getBaseModuleOptions('security'),
        ...options
    };
}

function callMethod(name, params) {
    return new Promise((resolve, reject) => {
        callPost(getCallOptions({
            name: name,
            body: {
                ...params
            },
            callback: getPromiseCallback(
                resolve, reject
            )
        }));
    });
}

export function checkSession(action) {
    return callMethod(
        'CheckSession',
        {
            sid: action.token
        }
    );
}

export function getPermissions(action) {
    return callMethod(
        'GetPermissions',
        {
            project_id: action.projectId,
            sid: action.token
        },
    );
}
